import React from "react";
import PropTypes from "prop-types";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";

const ObjectOptions = ({ options }) => {
  const { translate: t } = useLanguageProvider();
  return (options.map((option, i) => (
    <option key={`option.value_${i}`} value={option.value} data-testid={option.value}>
      {t(option.label)}
    </option>
  )));
};

ObjectOptions.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
  })),
};

export default ObjectOptions;
